import type { StaffDiagnosticsApi, StaffProviderHealthApi } from "@lafayette/api-client";
import { createContext, type ReactNode, useContext } from "react";

// What the diagnostics pages need from outside: the typed clients of provider health and of the diagnostics reads, and the clock. The admin app
// supplies the real ones (`admin-runtime.ts`); a test or the development harness supplies fakes. The re-run, pause and resume actions use the
// Operations runtime, and reconcile uses the Payments runtime: each action goes through the client of the area that owns it.

export type DiagnosticsRuntime = Readonly<{
  health: StaffProviderHealthApi;
  api: StaffDiagnosticsApi;
  now: () => Date;
}>;

const RuntimeContext = createContext<DiagnosticsRuntime | null>(null);

export function DiagnosticsRuntimeProvider({
  value,
  children,
}: Readonly<{ value: DiagnosticsRuntime; children: ReactNode }>) {
  return <RuntimeContext.Provider value={value}>{children}</RuntimeContext.Provider>;
}

export function useDiagnosticsRuntime(): DiagnosticsRuntime {
  const runtime = useContext(RuntimeContext);
  if (runtime === null) throw new Error("The diagnostics pages need a DiagnosticsRuntimeProvider.");
  return runtime;
}
